// import React, { useState } from "react";
// import {
//   TextField,
//   Button,
//   Grid,
//   Typography,
//   Box,
//   TextareaAutosize,
// } from "@mui/material";
// import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
// import Cropper from "react-easy-crop";
// import Slider from "@mui/material/Slider";
// import getCroppedImg from "./getCroppedImg"; // Helper function for cropping (see below)

// const AddSubNewRecipes = () => {
//   const [formData, setFormData] = useState({
//     user_id: "",
//     category_id: "",
//     ingredient_name: "",
//     prep_time: "",
//     cook_time: "",
//     num_servings: "",
//     nutri_facts: "",
//     equiprecipe_title: "",
//     summary: "",
//     created_at: "",
//     updated_at: "",
//     choice: "",
//     instructions: "",
//     alternative_methods: "",
//     cooking_tips: "",
//     expert_tips: "",
//     faqs: "",
//   });

//   const [image, setImage] = useState(null);
//   const [croppedArea, setCroppedArea] = useState(null);
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   const [zoom, setZoom] = useState(1);
//   const [croppedImage, setCroppedImage] = useState(null);
//   const [aspectRatio, setAspectRatio] = useState(1); // Aspect ratio control

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => {
//         setImage(reader.result);
//       };
//     }
//   };

//   const onCropComplete = (croppedArea, croppedAreaPixels) => {
//     setCroppedArea(croppedAreaPixels);
//   };

//   const handleCrop = async () => {
//     try {
//       const croppedImg = await getCroppedImg(image, croppedArea);
//       setCroppedImage(croppedImg);
//       alert("Image cropped successfully!");
//     } catch (error) {
//       console.error("Crop error:", error);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formDataToSend = new FormData();
//     for (const key in formData) {
//       formDataToSend.append(key, formData[key]);
//     }
//     if (croppedImage) formDataToSend.append("recipeImage", croppedImage);

//     try {
//       const response = await fetch(
//         "http://localhost:3090/api/recipe/recipeadderform",
//         {
//           method: "POST",
//           body: formDataToSend,
//         }
//       );

//       const result = await response.json();
//       if (response.ok) {
//         alert(result.message);
//       } else {
//         alert(result.message);
//       }
//     } catch (error) {
//       console.error("Error adding recipe:", error);
//       alert("Error adding recipe, try again later.");
//     }
//   };

//   return (
//     <Box sx={{ padding: 3 }}>
//       <Typography variant="h4" gutterBottom>
//         Add Recipe
//       </Typography>
//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={3}>
//           {/* Form Fields */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="User ID"
//               variant="outlined"
//               fullWidth
//               name="user_id"
//               value={formData.user_id}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* SubCategory ID */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Category ID"
//               variant="outlined"
//               fullWidth
//               name="category_id"
//               value={formData.category_id}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Meal Type Name */}

//           {/* Ingredient Name */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Ingredients (json)"
//               variant="outlined"
//               fullWidth
//               name="ingredient_name"
//               value={formData.ingredient_name}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Preparation Time */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Preparation Time (integer)"
//               variant="outlined"
//               fullWidth
//               name="prep_time"
//               value={formData.prep_time}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Cooking Time */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Cooking Time (integer)"
//               variant="outlined"
//               fullWidth
//               name="cook_time"
//               value={formData.cook_time}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Number of Servings */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Number of Servings"
//               variant="outlined"
//               fullWidth
//               name="num_servings"
//               value={formData.num_servings}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Nutritional Facts */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Nutritional Facts (json)"
//               variant="outlined"
//               fullWidth
//               name="nutri_facts"
//               value={formData.nutri_facts}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* FAQS */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="FAQS (json)"
//               variant="outlined"
//               fullWidth
//               name="faqs"
//               value={formData.faqs}
//               onChange={handleChange}
//             />
//           </Grid>
//           {/* EXPERT TIPS */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Expert tips (json)"
//               variant="outlined"
//               fullWidth
//               name="expert_tips"
//               value={formData.expert_tips}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/*  cooking tips */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Cooking tips (json)"
//               variant="outlined"
//               fullWidth
//               name="cooking_tips"
//               value={formData.cooking_tips}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* alternative methods */}

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Alternative methods (json)"
//               variant="outlined"
//               fullWidth
//               name="alternative_methods"
//               value={formData.alternative_methods}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* instructions */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Instructions (json)"
//               variant="outlined"
//               fullWidth
//               name="instructions"
//               value={formData.instructions}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* why love */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Why love(json)"
//               variant="outlined"
//               fullWidth
//               name="choice"
//               value={formData.choice}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Equipment Recipe Title */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Equipments(json)"
//               variant="outlined"
//               fullWidth
//               name="equiprecipe_title"
//               value={formData.equiprecipe_title}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Recipe Summary */}
//           <Grid item xs={12} md={6}>
//             <TextareaAutosize
//               minRows={3}
//               placeholder="conclusions"
//               style={{ width: "100%" }}
//               name="summary"
//               value={formData.summary}
//               onChange={handleChange}
//             />
//           </Grid>

//           {/* Created At */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Created At(date)"
//               variant="outlined"
//               fullWidth
//               name="created_at"
//               value={formData.created_at}
//               onChange={handleChange}
//               required
//             />
//           </Grid>

//           {/* Updated At */}
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Updated At(date)"
//               variant="outlined"
//               fullWidth
//               name="updated_at"
//               value={formData.updated_at}
//               onChange={handleChange}
//             />
//           </Grid>

//           <Box sx={{ mb: 2 }}>
//             <TextField
//               type="file"
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//               onChange={handleImageChange}
//             />
//           </Box>

//           {/* Aspect Ratio Slider */}
//           <Box sx={{ mb: 2 }}>
//             <Typography>Aspect Ratio: {aspectRatio}</Typography>
//             <Slider
//               value={aspectRatio}
//               min={0.1}
//               max={3}
//               step={0.1}
//               onChange={(e, newValue) => setAspectRatio(newValue)}
//             />
//           </Box>

//           {/* Other fields... */}

//           {/* Image Upload */}
//           <Grid item xs={12}>
//             <Button
//               variant="contained"
//               component="label"
//               startIcon={<CloudUploadIcon />}
//             >
//               Upload Recipe Image
//               <input type="file" hidden onChange={handleImageChange} />
//             </Button>
//           </Grid>

//           {/* Image Cropper */}
//           {image && (
//             <Box
//               sx={{
//                 marginTop: 3,
//                 position: "relative",
//                 height: 300,
//                 width: 300,
//               }}
//             >
//               <Cropper
//                 image={image}
//                 crop={crop}
//                 zoom={zoom}
//                 aspect={aspectRatio} // Set aspect ratio
//                 onCropChange={setCrop}
//                 onZoomChange={setZoom}
//                 onCropComplete={onCropComplete}
//               />
//               <Slider
//                 value={zoom}
//                 min={1}
//                 max={3}
//                 step={0.1}
//                 aria-labelledby="Zoom"
//                 onChange={(e, zoom) => setZoom(zoom)}
//                 sx={{ marginTop: 2 }}
//               />
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={handleCrop}
//                 sx={{ marginTop: 2 }}
//               >
//                 Crop Image
//               </Button>
//             </Box>
//           )}

//           {/* Submit Button */}
//           <Grid item xs={12}>
//             <Button variant="contained" color="primary" type="submit">
//               Add Recipe
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default AddSubNewRecipes;

import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

const AddSubNewRecipes = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    user_id: "",
    title_id: "",
    category_id: "",
    ingredient_name: "",
    prep_time: "",
    cook_time: "",
    num_servings: "",
    nutri_facts: "",
    equiprecipe_title: "",
    summary: "",
    instructions: "",
    alternative_methods: "",
    cooking_tips: "",
    expert_tips: "",
    faqs: "",
    tags: [],
    choice: "",
    created_at: "",
    updated_at: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      const response = await axios.post(
        `${API_URL}/subrecipe/subrecipeadderform`,
        formData
      );
      setLoading(false);
      setSuccessMessage(response.data.message);
    } catch (err) {
      setLoading(false);
      setError(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
    }
  };

  return (
    <Box sx={{ padding: 3, maxWidth: 800, margin: "0 auto" }}>
      <Typography variant="h4" gutterBottom>
        Add a subRecipes
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* User ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="User ID"
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Title ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title ID"
              type="number"
              name="title_id"
              value={formData.title_id}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Category ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Category ID"
              name="category_id"
              type="number"
              value={formData.category_id}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Choice */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Choice"
              name="choice"
              value={formData.choice}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Preparation Time */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Preparation Time (mins)"
              name="prep_time"
              type="number"
              value={formData.prep_time}
              onChange={handleChange}
            />
          </Grid>

          {/* Cooking Time */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Cooking Time (mins)"
              name="cook_time"
              type="number"
              value={formData.cook_time}
              onChange={handleChange}
            />
          </Grid>

          {/* Number of Servings */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Number of Servings"
              name="num_servings"
              type="number"
              value={formData.num_servings}
              onChange={handleChange}
            />
          </Grid>

          {/* Ingredient Name */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Ingredient Name"
              name="ingredient_name"
              value={formData.ingredient_name}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Equipment Recipe Title */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Equipment Recipe Title"
              name="equiprecipe_title"
              value={formData.equiprecipe_title}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Instructions */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Instructions"
              name="instructions"
              value={formData.instructions}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Alternative Methods */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Alternative Methods"
              name="alternative_methods"
              value={formData.alternative_methods}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Cooking Tips */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Cooking Tips"
              name="cooking_tips"
              value={formData.cooking_tips}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Expert Tips */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Expert Tips"
              name="expert_tips"
              value={formData.expert_tips}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Nutritional Facts */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nutritional Facts"
              name="nutri_facts"
              value={formData.nutri_facts}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* FAQs */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="FAQs"
              name="faqs"
              value={formData.faqs}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Summary */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Summary"
              name="summary"
              value={formData.summary}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Tags */}
          {/* <Grid item xs={12}>
            <TextField
              fullWidth
              label="Tags"
              name="tags"
              value={formData.tags}
              onChange={handleChange}
            />
          </Grid> */}

          {/* Tags */}
          <Grid item xs={12}>
            <TextField
              label="Tags (comma separated)"
              name="tags"
              value={formData.tags.join(", ")}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tags: e.target.value.split(",").map((tag) => tag.trim()),
                })
              }
              fullWidth
            />
          </Grid>

          {/* Created At */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Created At"
              name="created_at"
              type="date"
              value={formData.created_at}
              onChange={handleChange}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          {/* Updated At */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Updated At"
              name="updated_at"
              type="date"
              value={formData.updated_at}
              onChange={handleChange}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} sm={6}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit Recipe"
              )}
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* Error and Success Messages */}
      {error && (
        <Typography color="error" variant="body2" mt={2}>
          {error}
        </Typography>
      )}

      {successMessage && (
        <Typography color="primary" variant="body2" mt={2}>
          {successMessage}
        </Typography>
      )}
    </Box>
  );
};

export default AddSubNewRecipes;
